<template>
  <div>
    <transaction-tabs v-if="usage == 'imprest'" :type="usage"></transaction-tabs>
    <m-form
      :title="title"
      :items="items"
      :cols="cols"
      :canClear="false"
      :canSubmit="canSubmit"
      :canDelete="false"
      :showSubmitAndClearBtn="false"
      :is-editing.sync="isEditing"
      :showListBtn="false"
      :show-navigation-btns="false"
      :show-clear-btn="false"
      @click:row="setItem"
      @clearForm="clearForm"
      @submit="submit"
      @delete="deleteItem"
    >
      <template #header-btns>
        <div v-if="usage == 'receive' || usage == 'payment' || usage == 'guarantee'">
          <v-btn
            depressed
            :color="usage == 'receive' ? 'primary' : 'secondary'"
            class="rounded-lg white--text mr-1"
            @click="goUsage('receive')"
            >دریافت
          </v-btn>
          <v-btn
            depressed
            :color="usage == 'payment' ? 'primary' : 'secondary'"
            class="rounded-lg white--text mr-1"
            @click="goUsage('payment')"
            >پرداخت
          </v-btn>
          <v-btn
            depressed
            :color="usage == 'guarantee' ? 'primary' : 'secondary'"
            class="rounded-lg white--text mr-1"
            @click="goUsage('guarantee')"
            >اسناد ضمانتی
          </v-btn>
        </div>
        <div v-if="usage == 'factor'">
          <v-btn depressed class="primary rounded-lg white--text mr-1" @click="clearForm">حساب </v-btn>
          <v-btn depressed class="secondary rounded-lg white--text mr-1" :to="`/panel/defaultTexts/factor`"
            >پی نوشت
          </v-btn>
          <template v-if="hasFeature('FACTOR_EXPENSES')">
          <v-btn depressed class="secondary rounded-lg white--text mr-1" :to="`/panel/factor/expenses/buy`"
            >هزینه های خرید
          </v-btn>
          <v-btn depressed class="secondary rounded-lg white--text mr-1" :to="`/panel/factor/expenses/sale`"
            >هزینه های فروش
          </v-btn>
          </template>
        </div>
      </template>

      <template #default>
        <v-row>
          <v-col cols="12">
            <v-text-field class="rounded-lg" label="نام" v-model="item.name" :disabled="true" />
          </v-col>
          <v-col cols="12">
            <account-select
              :disabled="!isEditing"
              label=" * حساب"
              :itemsType="accountLevel"
              v-model="item.account"
              :floatAccount1.sync="item.floatAccount1"
              :floatAccount2.sync="item.floatAccount2"
              :floatAccount3.sync="item.floatAccount3"
              :floatAccount4.sync="item.floatAccount4"
            />
          </v-col>
          <v-col cols="12">
            <v-textarea class="rounded-lg" label="توضیحات" v-model="item.explanation" :disabled="!isEditing" />
          </v-col>
        </v-row>
      </template>

      <template #item.detail="{ item }">
        <v-btn
          depressed
          class="rounded-lg"
          v-if="usage == 'imprest'"
          color="info white--text"
          :to="{ name: 'Accounts', params: { level: 3 }, query: { parent: item.account.id } }"
          >تعریف حساب تفصیلی
        </v-btn>
      </template>
    </m-form>
  </div>
</template>
<script>
import AccountApiMixin from "@/mixin/accountMixin";
import { MFormMixin } from "@/components/m-form";
import TransactionTabs from "@/views/panel/transaction/TransactionTabs";
import { isFunction } from "lodash";

export default {
  components: { TransactionTabs },
  mixins: [MFormMixin, AccountApiMixin],
  props: {
    usage: {
      requried: true,
    },
  },
  data() {
    return {
      item: {},
      baseUrl: "accounts/defaultAccounts",
      permissionBasename: "defaultAccount",
      cols: [
        {
          text: "نام",
          value: "name",
          type: "text",
        },
        {
          text: "حساب",
          value: "account.title",
          type: "text",
        },
        {
          text: "",
          value: "detail",
          filterable: false,
          sortable: false,
        },
      ],
    };
  },
  computed: {
    title() {
      let title = "پیشفرض ";
      if (this.usage == "receive")  title += "های خزانه داری > دریافت";
      if (this.usage == "payment")  title += "های خزانه داری > پرداخت";
      if (this.usage == "factor")  title += "های فاکتور > حساب";
      if (this.usage == "closeAccounts")  title += "بستن حساب ها";
      if (this.usage == "imprest") title = "تعریف تنخواه گردان";
      if (this.usage == "other") title = "سایر پیش فرض ها";
      if (this.usage == "costAccounting") title = "بهای تمام شده";
      if (this.usage == "guarantee")  title += "های خزانه داری > اسناد انتظامی";
      return this.setDocumentTitle(title)
    },
    accountLevel() {
      if (this.usage == "imprest") return "level2";
      return `level${this.item.account_level || 3}`;
    },
    items() {
      return this.defaultAccounts.filter((o) => {
        if (o.usage && o.usage.toLowerCase().includes(this.usage.toLowerCase())) {
          if (!o.warehouse_system || o.warehouse_system == this.financialYear.warehouse_system) {
            return true;
          }
        }
      });
    },
    canSubmit() {
      return true;
      if (this.item.is_editable) return false;
      if (this.item.id || ["imprest", "receive", "payment"].includes(this.usage)) return true;
      return false;
    },
  },
  methods: {
    goUsage(form_usage) {
      if (this.usage == form_usage) {
        this.clearForm();
      } else {
        this.$router.push("/panel/defaultAccounts/" + form_usage);
      }
    },
    getItemTemplate() {
      return {
        usage: this.usage,
        is_editable: true,
      };
    },
    getData() {
      this.getDefaultAccounts(true);
      this.getAccounts();
    },
    setItem(item) {
      this.item = item;
    },
    getSerialized() {
      let item = this.extractIds(this.item);
      if (!item.account_level) {
        let level = 3;
        if (this.usage == "imprest") level = 2;
        item.account_level = level;
      }
      return item;
    },
  },
};
</script>
